import type { TranslateRecordType } from '../types'

export const translateMap: TranslateRecordType = {
  指标名称: {
    'en-US': 'MeasureName',
    'zh-CN': '指标名称',
    'ja-JP': 'メジャー名',
    'de-DE': 'Kennzahlname',
    'id-ID': 'Nama Ukuran',
    'fr-FR': 'Nom de mesure',
    'ko-KR': '측정값 이름',
    'vi-VN': 'Tên chỉ số',
  },
  指标Id: {
    'en-US': 'MeasureId',
    'zh-CN': '指标Id',
    'ja-JP': 'メジャーID',
    'de-DE': 'Kennzahl-ID',
    'id-ID': 'ID Ukuran',
    'fr-FR': 'ID de mesure',
    'ko-KR': '측정값 ID',
    'vi-VN': 'ID chỉ số',
  },
  指标值: {
    'en-US': 'MeasureValue',
    'zh-CN': '指标值',
    'ja-JP': 'メジャー値',
    'de-DE': 'Kennzahlwert',
    'id-ID': 'Nilai Ukuran',
    'fr-FR': 'Valeur de mesure',
    'ko-KR': '측정값',
    'vi-VN': 'Giá trị chỉ số',
  },
  异常点: {
    'en-US': 'Outlier',
    'zh-CN': '异常点',
    'ja-JP': '外れ値',
    'de-DE': 'Ausreißer',
    'id-ID': 'Pencilan',
    'fr-FR': 'Valeur aberrante',
    'ko-KR': '이상치',
    'vi-VN': 'Điểm ngoại lai',
  },
  上边界: {
    'en-US': 'Upper Whisker',
    'zh-CN': '上边界',
    'ja-JP': '上ひげ',
    'de-DE': 'Oberer Whisker',
    'id-ID': 'Whisker atas',
    'fr-FR': 'Moustache supérieure',
    'ko-KR': '위쪽 수염',
    'vi-VN': 'Râu trên',
  },
  上四分位数: {
    'en-US': 'Q3',
    'zh-CN': '75分位数',
    'ja-JP': 'Q3',
    'de-DE': 'Q3',
    'id-ID': 'Q3',
    'fr-FR': 'Q3',
    'ko-KR': 'Q3',
    'vi-VN': 'Q3',
  },
  中位数: {
    'en-US': 'Q2',
    'zh-CN': '中位数',
    'ja-JP': 'Q2',
    'de-DE': 'Q2',
    'id-ID': 'Q2',
    'fr-FR': 'Q2',
    'ko-KR': 'Q2',
    'vi-VN': 'Q2',
  },
  下四分位数: {
    'en-US': 'Q1',
    'zh-CN': '25分位数',
    'ja-JP': 'Q1',
    'de-DE': 'Q1',
    'id-ID': 'Q1',
    'fr-FR': 'Q1',
    'ko-KR': 'Q1',
    'vi-VN': 'Q1',
  },
  下边界: {
    'en-US': 'Lower Whisker',
    'zh-CN': '下边界',
    'ja-JP': '下ひげ',
    'de-DE': 'Unterer Whisker',
    'id-ID': 'Whisker bawah',
    'fr-FR': 'Moustache inférieure',
    'ko-KR': '아래쪽 수염',
    'vi-VN': 'Râu dưới',
  },
  总计: {
    'en-US': 'Total',
    'zh-CN': '总计',
    'ja-JP': '合計',
    'de-DE': 'Gesamt',
    'id-ID': 'Total',
    'fr-FR': 'Total',
    'ko-KR': '총계',
    'vi-VN': 'Tổng',
  },
  小计: {
    'en-US': 'Sub Total',
    'zh-CN': '小计',
    'ja-JP': '小計',
    'de-DE': 'Zwischensumme',
    'id-ID': 'Subtotal',
    'fr-FR': 'Sous-total',
    'ko-KR': '소계',
    'vi-VN': 'Tổng phụ',
  },
  合计: {
    'en-US': 'Total',
    'zh-CN': '合计',
    'ja-JP': '合計',
    'de-DE': 'Gesamt',
    'id-ID': 'Total',
    'fr-FR': 'Total',
    'ko-KR': '합계',
    'vi-VN': 'Tổng',
  },
  平均: {
    'en-US': 'Average',
    'zh-CN': '平均',
    'ja-JP': '平均',
    'de-DE': 'Durchschnitt',
    'id-ID': 'Rata-rata',
    'fr-FR': 'Moyenne',
    'ko-KR': '평균',
    'vi-VN': 'Trung bình',
  },
  最大值: {
    'en-US': 'Max',
    'zh-CN': '最大值',
    'ja-JP': '最大',
    'de-DE': 'Max.',
    'id-ID': 'Maks',
    'fr-FR': 'Max',
    'ko-KR': '최대',
    'vi-VN': 'Tối đa',
  },
  最小值: {
    'en-US': 'Min',
    'zh-CN': '最小值',
    'ja-JP': '最小',
    'de-DE': 'Min.',
    'id-ID': 'Min',
    'fr-FR': 'Min',
    'ko-KR': '최소',
    'vi-VN': 'Tối thiểu',
  },
  计数: {
    'en-US': 'Count',
    'zh-CN': '计数',
    'ja-JP': '件数',
    'de-DE': 'Anzahl',
    'id-ID': 'Hitung',
    'fr-FR': 'Nombre',
    'ko-KR': '개수',
    'vi-VN': 'Số lượng',
  },
}
